// extracted by mini-css-extract-plugin
module.exports = {"container":"ParamButton_container__I0BA1","button":"ParamButton_button__1utQw","text":"ParamButton_text__2XqEw"};